<h1>Support</h1>

<div class="flex-container" style="margin-bottom: 25px">
  <div class="column">
    <app-spotlight [title]="'Phone'">
      <ng-template #body>
        <div style="text-align: center; padding: 40px 0px">
          <div style="margin-bottom: 20px">
            <i class="fa-solid fa-phone"></i>
          </div>

          <p style="font-size: 1.5em">
            Call us: <a href="tel:+1844-356-9905">844-356-9905</a>
          </p>
        </div>
      </ng-template>

      <ng-template #footer>
        <input type="button" value="Have us call you" />
      </ng-template>
    </app-spotlight>
  </div>

  <div class="column">
    <app-spotlight [title]="'Email'">
      <ng-template #body>
        <div style="text-align: center; padding: 40px 0px">
          <div style="margin-bottom: 20px">
            <i class="fa-solid fa-envelope"></i>
          </div>

          <p>Swipesum Support terminal</p>
          <p>support&#39;swipesum.com</p>
        </div>
      </ng-template>

      <ng-template #footer>
        <div style="display: table; width: 100%">
          <div style="display: table-row">
            <div style="display: table-cell; width: 50%; text-align: center">
              <input
                type="button"
                value="More Info"
                style="width: 90%; margin: 0% auto"
              />
            </div>
            <div
              style="
                display: table-cell;
                width: 50%;
                text-align: center;
                text-align: center;
              "
            >
              <input
                type="button"
                value="Manage"
                style="width: 90%; margin: 0% auto"
              />
            </div>
          </div>
        </div>
      </ng-template>
    </app-spotlight>
  </div>

  <div class="column">
    <!-- <app-spotlight [title]="'Chat'">
            <ng-template #body>
                <div style="text-align:center; padding:40px 0px;">

                    <div style="margin-bottom:20px;">
                        <i class="fa-regular fa-comments"></i> 
                    </div>
    
                    <p>Use the chat feature located in the bottom-left of every page</p>
                </div>
            </ng-template>

            <ng-template #footer>
                <app-launch-chat-button [showIcon]="false"></app-launch-chat-button>
            </ng-template>
        </app-spotlight>  -->
  </div>
</div>
